import { useQuery } from "@tanstack/react-query";
import * as AgenticV2API from "@/services/api/agentic-v2";
import { useWindowLive } from "@/components/ui/os-layout/WindowActiveContext";
import { missionControlKeys } from "./keys";

export interface UseMissionArtifactsOptions {
  missionId: string;
  enabled?: boolean;
}

/** Cached mission artefacts list; gated by OS window lifecycle and parent tab visibility. */
export function useMissionArtifacts({
  missionId,
  enabled: enabledOption = true,
}: UseMissionArtifactsOptions) {
  const isWindowLive = useWindowLive();
  const queryEnabled = enabledOption && isWindowLive && Boolean(missionId);

  return useQuery({
    queryKey: missionControlKeys.missionArtifacts(missionId),
    enabled: queryEnabled,
    refetchOnWindowFocus: queryEnabled,
    queryFn: () => AgenticV2API.listMissionArtifacts(missionId),
  });
}
